import styled from "@emotion/styled";

import FlexContainer from "shared/components/FlexContainer";

export const IntegrationsExtraControlsWrapper = styled(FlexContainer)`
  margin-left: auto;
`;
